import type { IErrorResponse, News, PaginationResponse } from '@/types';

import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import queryString from 'query-string';

import { urls } from '@/statics';
import { api } from '@/utils';

const useGetNews = (): UseMutationResult<
  PaginationResponse<News>,
  IErrorResponse,
  {
    pageSize?: number;
    current?: number;
    sortBy?: 'newest' | 'is_most_viewed' | 'is_most_rated';
  }
> => {
  return useMutation({
    mutationFn: (queries: {
      pageSize?: number;
      current?: number;
      sortBy?: 'newest' | 'is_most_viewed' | 'is_most_rated';
    }) => api.get(`${urls.news}?${queryString.stringify(queries)}`),
  });
};

export default useGetNews;
